import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Internal Imports
import './ListadoEncuesta.css';
import MenuLayout from "../../common/components/MenuLayout/MenuLayout";
import SearchText from "../../common/components/SearchText/SearchText";
import SurveyItem from "../../common/components/SurveyItem/SurveyItem";
import { COLORS } from "../../common/constants/colors";
import { IPropsMenu } from "../../interfaces/IPropsMenu";
import { ISurvey } from "../../interfaces/ISurvey";
import { GetSurvey } from "../../services/survey";
import { VisualizacionFormulario } from "../../common/enums/AllEnums";
import { useForm } from "../../contexts/form";
import { getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import LabelNotFound from "../../common/components/Label/LabelNotFound";
import LoadingPage from "../../common/components/LoadingPage/LoadingPage";

const ListadoEncuesta: React.FC<IPropsMenu> = ({ menu }) => {
    const [searchV, setSearchV] = useState<string>('');
    const [listSurvey, setListSurvey] = useState<ISurvey[]>([]);
    const { setQuestionForm } = useForm();
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const navigate = useNavigate();


    //Method
    const goToEntitySurvey = (survey: ISurvey) => {

        setQuestionForm(survey);
        //Formulario Tabla
        if (survey.visualizacionTipoNombre === VisualizacionFormulario.Tabla) {
            if (survey.esFormularioSecuencial === true) {
                navigate(`/SequentialSurvey`);
            } else {
                navigate(`/EncuestaNoSequencial`);
            }
        }
        //Formulario Listado & Listado Detalle
        if (survey.visualizacionTipoNombre === VisualizacionFormulario.Listado || survey.visualizacionTipoNombre === VisualizacionFormulario.ListadoDetalle) {
            navigate(`/EntidadEncuesta`);
        }
    }



    const getListSurveysFiltered = useCallback(() => {
        let surveysFiltered: ISurvey[] = [];
        const valueLowerCase = searchV.toLowerCase();
        if (!!valueLowerCase) {
            surveysFiltered = listSurvey.filter((list) =>
                list.nombre?.toLowerCase().includes(valueLowerCase))
        } else {
            surveysFiltered = listSurvey
        }
        return surveysFiltered;
    }, [searchV, listSurvey])

    const getSurvey = () => {
        tryCatch(() => {
            setFormLoading(true);
            GetSurvey().then(response => {
                setListSurvey(response.data)

            })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setFormLoading(false));
        })

    }

    useEffect(() => {
        getSurvey();
    }, []);


    return (

        <MenuLayout currentPage={menu.nombre}>
            <div className="listSurvey_container">
                <SearchText
                    value={searchV}
                    active={true}
                    borderColor={COLORS.black_back_color5}
                    textColor={COLORS.black_text_color1}
                    placeholdercolor={COLORS.black_text_color4}
                    name={"search_table"}
                    onChange={setSearchV}
                    placeholder={"Buscar"}
                    backgroundcolor={COLORS.black_back_color5}
                    opacity={1}
                    props={{ collapsed: 'false' }}
                />

                <div className="listSurvey_sesion" style={{height: '530px', overflowY:'auto', padding:'10px'}}>

                    {formLoading.toString() === 'true'
                        ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                        : getListSurveysFiltered().length === 0 ? <div className="loading-container"><LabelNotFound message="No se encontró data." /></div>
                            :
                            getListSurveysFiltered().map((survey: ISurvey) =>
                                <SurveyItem key={survey.formularioID}
                                    active={survey.visualizacionTipoNombre === VisualizacionFormulario.Mapa ? false : true}
                                    backgroundcolorheader={COLORS.blue_inactive(1)}
                                    backgroundcolorbody={COLORS.black_back_color5}
                                    item={survey}
                                    borderColor={COLORS.black_shadow_1}
                                    props={{ collapsed: 'false' }}
                                    textColor={COLORS.blue_main(1)}
                                    method={() => goToEntitySurvey(survey)}
                                />
                            )

                    }
                </div>
            </div>
        </MenuLayout>
    )
}

export default ListadoEncuesta;